import { render, staticRenderFns } from "./r-icon-button.vue?vue&type=template&id=50e4af62"
import script from "./r-icon-button.vue?vue&type=script&lang=js"
export * from "./r-icon-button.vue?vue&type=script&lang=js"
import style0 from "./r-icon-button.vue?vue&type=style&index=0&id=50e4af62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports